$(function() {

    var element = $('.i4-site__visual');
    checkVisualPosition(element);

    // Listen for orientation changes
    window.addEventListener("orientationchange", function() {
        checkVisualPosition(element);
    }, false);

    // Listen for window size changes
    window.addEventListener("resize", function() {
        checkVisualPosition(element);
    }, false);
});

function checkVisualPosition(visual) {
    var minWidth = 1024; // l-breakpoint

    if(window.innerWidth <= minWidth) {
        moveVisualToScrollArea(visual);
    } else {
        moveVisualToSidebar(visual);
    }
}

function moveVisualToScrollArea(visual) {
    if (!visual.hasClass('i4-site__visual--mobile')) {
        visual.addClass('i4-site__visual--mobile');
        visual.detach().appendTo('.i4-site__scrollarea');
    }
}

function moveVisualToSidebar(visual) {
    if (visual.hasClass('i4-site__visual--mobile')) {
        visual.removeClass('i4-site__visual--mobile');
        visual.detach().prependTo('.i4-site');
    }
}
